import { useEffect } from 'react';
import { useShallow } from 'zustand/shallow';

import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

interface ShadowsUpdateHandlerProps {
    isMainCanvas: boolean;
}

/**
 * Updates shadow casting and receiving state for all batched meshes when shadow settings change.
 */
export const useShadowsUpateHandler = ({ isMainCanvas }: ShadowsUpdateHandlerProps) => {
    const shadowsEnabled = usePlacementStore(useShallow((state) => state.graphicsSettings.shadowsEnabled));

    useEffect(() => {
        const state = usePlacementStore.getState();
        const batchedMeshes = isMainCanvas ? state.batchedMeshes : state.navigatorBatchedMeshes;

        if (!batchedMeshes.physical) {
            return;
        }

        batchedMeshes.physical.castShadow = shadowsEnabled;
        batchedMeshes.physical.receiveShadow = shadowsEnabled;

        if (batchedMeshes.sheet) {
            batchedMeshes.sheet.castShadow = shadowsEnabled;
            batchedMeshes.sheet.receiveShadow = shadowsEnabled;
        }
    }, [shadowsEnabled, isMainCanvas]);
};
